import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalMiddleWrapper from "layouts/wrapper/VerticalMiddleWrapper";
import style from "./OverlayMenu.module.css";
// import { ReactComponent as Logo } from "resources/img/logo/logo_horizontal.svg";

function OverlayMenuBaseHeader({ modalClose }) {
    return (
        <div className={style.header}>
            <HorizontalFlex>
                <FlexChild width={50}>
                    <a className={style.headerCloseButton} onClick={modalClose}>
                        <FontAwesomeIcon icon={fas["faArrowRight"]} />
                    </a>
                </FlexChild>
                <FlexChild>
                    <div className={style.logoArea}>
                        {/* <Logo className={style.logo} /> */}
                    </div>
                </FlexChild>
                <FlexChild width={50}>
             
                </FlexChild>
            </HorizontalFlex>
        </div>
    );
}

export default OverlayMenuBaseHeader;